import { initCourseSignupDialogs } from './modules/course-signup-dialog.js';

document.addEventListener('DOMContentLoaded', () => {
	initCourseSignupDialogs();
});
